module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_05_770_280_en-adb7d54c07eea94dcb2995b4ba5a02be.jpg";